// extracted by mini-css-extract-plugin
export default {"sendEmailDrawer":"styles_sendEmailDrawer__oZLJk","shadowDisabled":"styles_shadowDisabled__IIkro","emailPreview":"styles_emailPreview__gUMfJ","editor":"styles_editor__udxS9"};